export default "__VITE_ASSET__CcmP5YsL__"